export enum Routes_Dashboard {
  // ------------------------------ AUTH ------------------------------ //
  AUTH_LOGIN = '/login',
  AUTH_CONFIRM_EMAIL = '/login/confirm',

  // ------------------------------ LEWKBOARD ------------------------------ //
  LEWKBOARD_GENERATE = "/lewkboard/new",
  LEWKBOARD_VIEW = "/lewkboard/view",
  LEWKBOARD_SUGGESTED = "/lewkboard/suggested",

  // ------------------------------ LEWKEDIT ------------------------------ //
  // LEWKEDIT_HOME = "/lewkedit",

  // ------------------------------ COLLECTIONS ------------------------------ //
  LEWKBOARD_COLLECTIONS = "/collections",
  COLLECTIONS_VIEW = "/collections/view",
  // Test
}

